import { Component, OnInit } from '@angular/core';
import "@maersk-global/mds-components-core/mc-card";
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-un-athourised',
  templateUrl: './un-athourised.component.html',
  styleUrls: ['./un-athourised.component.scss']
})
export class UnAthourisedComponent implements OnInit {
  constructor(private router:Router, private authService:MsalService) {

  }

  ngOnInit(): void {
    const activeAccount = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();

    if (!activeAccount && allAccounts.length > 0) {
      this.authService.instance.setActiveAccount(allAccounts[0]);
    }
  }
}
